const KEY = 'haebom.sessionId'

export function getSessionId(): string | undefined {
  try {
    const existing = sessionStorage.getItem(KEY)
    if (existing !== null && existing !== '') return existing
    // API의 형식 제한(영숫자·하이픈·밑줄 8~64자)에 맞춰 하이픈을 뺀 32자로 만든다.
    const id = crypto.randomUUID().replace(/-/g, '')
    sessionStorage.setItem(KEY, id)
    return id
  } catch {
    return undefined
  }
}
